import React, { useState } from 'react';
import LangToggle from '../components/LangToggle';
import { useLang, translations } from '../i18n';
import Footer from '../components/Footer';

const CREATE_LOCKER_URL = process.env.REACT_APP_CREATE_LOCKER_URL!;

const LockerAuth: React.FC<{ onSuccess: () => void }> = ({ onSuccess }) => {
  const { lang } = useLang();
  const t = translations[lang];
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(CREATE_LOCKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password })
      });
      const data = await res.json();
      if (data.message === 'valid') {
        onSuccess();
      } else {
        setError('Mot de passe incorrect');
      }
    } catch {
      setError('Erreur de connexion');
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <form className="login-form" onSubmit={handleSubmit}>
        <div style={{display:'flex',justifyContent:'center',marginBottom:24,position:'relative'}}>
          <img src={process.env.PUBLIC_URL + '/recat-logo-1024.png'} alt="Logo" style={{height:80}} />
          <div style={{position:'absolute',right:0,top:0}}>
            <LangToggle />
          </div>
        </div>
        <h2>{t.lockerTitle}</h2>
        <input type="password" placeholder={t.lockerPassword} value={password} onChange={e => setPassword(e.target.value)} required />
        <button type="submit" disabled={loading}>{loading ? t.lockerLoading : t.lockerBtn}</button>
        {error && <div className="login-error">{error === 'Mot de passe incorrect' ? t.lockerError : t.loginErrorNetwork}</div>}
      </form>
    </div>
  );
};

export default LockerAuth;

// Footer injection


